<mat-card role="region" aria-label="Fehlermeldung" class="error-box-card max-w-[50rem] pr-16">
  <div class="flex items-center">
    <mat-icon class="w-7 h-7" svgIcon="fi-fehler-20"></mat-icon>
    <div class="mu-heading-2 pl-[0.8rem]">{{errorTitle}}</div>
  </div>
  <div class="pt-4 pl-[2.8rem]">
    {{errorText}}
  </div>
  @if (errorInfo?.errorLink) {
    <div class="pl-[2.8rem]">
      <a href="{{errorInfo?.errorLink}}" target="_blank" >{{errorInfo?.errorLinkText}} </a>
    </div>
  }
  @if (showServiceTimeNotice) {
    <div class="pt-4 pl-[2.8rem]">
      {{'error-box.service_time_notice' | translate}}
    </div>
  }
</mat-card>
